const OverTimeComponent = () => import('@/views/hrm/overtime/OverTimeView')

export default [
    {
        path:'/OverTimeIndex',
        name:'OverTimeComponent',
        component:OverTimeComponent
    }
]